export default __webpack_public_path__ + "static/media/milestone 300.74b518e2.svg";